import { heroStats, quickEntries } from '@/mocks/material';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200/80">
      {/* 顶部细线装饰 */}
      <div className="absolute inset-x-0 top-0 flex">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="h-1 flex-1 border-r border-background-300/40 bg-background-100" />
        ))}
      </div>

      <div className="mx-auto grid max-w-[1240px] gap-12 px-4 pb-12 pt-14 md:px-6 md:pb-16 md:pt-20 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
        {/* 左：文案 + 入口 */}
        <div className="flex flex-col justify-center">
          <p className="inline-flex items-center gap-2 self-start rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-archive-2-line" />
            历史黑料与往期爆料存档 · 持续回翻中
          </p>

          <h1 className="font-heading mt-6 text-3xl font-black leading-snug tracking-tight text-foreground-950 md:text-[44px] md:leading-[1.2]">
            把被冲淡的旧瓜，
            <br />
            <span className="text-primary-600">按时间重新摊开</span>
          </h1>

          <p className="mt-6 max-w-xl text-sm leading-7 text-foreground-600 md:text-base">
            看料网回翻<b className="font-semibold text-foreground-800">历史黑料</b>与
            <b className="font-semibold text-foreground-800">往期爆料存档</b>，旧料回顾专区把往年事件、
            <b className="font-semibold text-foreground-800">过往大瓜</b>逐档摊开。想看某人某段被遗忘的长期瓜，
            直接进<b className="font-semibold text-foreground-800">翻旧账合集</b>，连线索一起补齐。
          </p>

          {/* 检索/入口条 */}
          <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:items-center">
            <label className="flex w-full items-center gap-3 rounded-md border border-background-300 bg-background-50 px-4 py-3 transition-colors focus-within:border-primary-400 sm:max-w-sm">
              <i className="ri-search-line text-base text-foreground-400" />
              <input
                type="text"
                placeholder="搜人物 / 年份 / 题材"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </label>
            <button
              type="button"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              查档入库
            </button>
          </div>

          {/* 快捷入口 chips */}
          <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {quickEntries.map((q) => (
              <a
                key={q.label}
                href="#timeline"
                className="group flex flex-col items-start gap-1 rounded-md border border-background-200 bg-background-100/60 px-4 py-3 transition-colors hover:border-primary-300 hover:bg-background-50"
              >
                <i className={`${q.icon} text-lg text-primary-600`} />
                <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-700">
                  {q.label}
                </span>
              </a>
            ))}
          </div>
        </div>

        {/* 右：图文并重 */}
        <div className="relative">
          <div className="relative h-[360px] overflow-hidden rounded-lg border border-background-200 md:h-[460px]">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20archival%20research%20table%20with%20stacked%20aged%20newspaper%20clippings%2C%20printed%20headlines%20partially%20cut%20and%20scattered%20on%20a%20warm%20cream%20desk%2C%20vermillion%20red%20marker%20underlines%20and%20circled%20dates%2C%20small%20paper%20date%20labels%20and%20film%20timestamps%2C%20analog%20evidence%20mood%2C%20warm%20tungsten%20light%2C%20subtle%20film%20grain%2C%20restrained%20palette%20of%20cream%20ink%20black%20and%20warm%20red%20highlights%2C%20photorealistic%20still%20life%2C%20high%20detail%2C%20uncluttered&width=1180&height=1340&seq=hero-archive-01&orientation=portrait"
              alt="旧报纸剪报与标注日期堆叠在暖色桌面的历史黑料存档桌面"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 via-transparent to-transparent" />
            <span className="absolute left-3 top-3 rounded-sm bg-background-50/90 px-2 py-1 text-[11px] font-semibold text-primary-700">
              编号 KW-2016-0001 · 最早入档
            </span>
          </div>

          <div className="absolute -bottom-5 -right-2 hidden max-w-[240px] rounded-lg border border-background-200 bg-background-50 p-4 shadow-[0_10px_30px_-18px_rgba(40,28,10,0.45)] md:block">
            <p className="font-heading text-xs font-bold leading-relaxed text-foreground-950">
              “证据只看原话，
              <br />
              时间只信原档。”
            </p>
            <p className="mt-2 text-[11px] text-foreground-500">—— 旧料回顾 · 归档守则</p>
          </div>
        </div>
      </div>

      {/* 数据带 */}
      <div className="border-t border-background-200/80 bg-background-100/70">
        <div className="mx-auto grid max-w-[1240px] grid-cols-2 gap-y-5 px-4 py-6 sm:grid-cols-4 md:px-6">
          {heroStats.map((s) => (
            <div key={s.label} className="flex flex-col items-start gap-0.5 border-r border-background-200/70 last:border-r-0 sm:items-center">
              <span className="font-heading text-2xl font-black text-primary-600">{s.value}</span>
              <span className="text-xs text-foreground-500">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}